import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
	ComponentBase,
	DeploymentContext,
	LogoSize,
	WebAnalyticsService,
} from '@Common';
import {
	Company,
	convertToValidWebsiteUrl,
	isNewCompany,
	LocalizedTextIds,
	orderByTagCount,
	TagWithCount,
	urlIdentifierForCompany,
} from 'company-finder-common';
@Component({
	selector: 'company-summary',
	templateUrl: './company-summary.component.html',
	styleUrls: ['./company-summary.component.scss'],
	standalone: false,
})
export class CompanySummaryComponent extends ComponentBase implements OnInit {
	@Input()
	public company: Company;
	public isShowingLocationsTooltip = false;
	public logoSize: LogoSize = LogoSize.ExtraLarge;
	@Input()
	public tagCounts: TagWithCount[];
	public isShowingTooltip = false;
	public tagsToDisplay: string[] = [];

	@ViewChild('summary')
	private self: ElementRef;

	public get height(): number {
		return this.self?.nativeElement?.offsetHeight ?? 0;
	}

	public constructor(
		dc: DeploymentContext,
		private _router: Router,
		private _webAnalyticsService: WebAnalyticsService
	) {
		super(dc);
	}

	ngOnInit(): void {
		this.tagsToDisplay = orderByTagCount(this.company, this.tagCounts);
	}

	public get isNew(): boolean {
		return isNewCompany(this.company);
	}

	public get assetCountLabel(): string {
		return `${this.company.assets.length} ${
			this.company.assets.length === 1
				? this.Loc(LocalizedTextIds.Asset)
				: this.Loc(LocalizedTextIds.Assets)
		}`;
	}

	public get encodedName(): string {
		return urlIdentifierForCompany(this.company.name);
	}

	public onClick(): void {
		if (
			!this._deploymentContext.featureSwitches.restrictToSearchResultsPage
		) {
			this._router.navigate(['company', this.encodedName]);
		} else {
			const externalCompanyURL = convertToValidWebsiteUrl(
				this.company.website
			);
			if (externalCompanyURL) {
				window.open(externalCompanyURL, '_blank');
			}
		}
		this._webAnalyticsService.trackEvent('select-company-from-summary', {
			category: 'Company Details',
			label: this.company.name,
		});
	}
}
